import React from "react"
import {FieldManagementPreviewProps} from "../../../../render/management-preview";
import FieldView from "../../../../render/view";


export default function FieldCurrency_ManagementPreview(props: FieldManagementPreviewProps) {

    const model : any = {}
    model[props.field.fieldId] = "320.95"

    return <FieldView field={props.field} model={model} />
}